/* ==========================================================================
   ZWANZE — cart-drawer.js
   Tiroir de panier. Hérite de Zwanze.Panel (focus, Échap, scroll).
   Se rafraîchit via la Section Rendering API : aucun balisage dupliqué en JS.
   ========================================================================== */
(function () {
  'use strict';
  const Z = window.Zwanze;
  if (!Z) return;

  class CartDrawer extends Z.Panel {
    connectedCallback() {
      super.connectedCallback();
      this._contents = this.querySelector('[data-cart-contents]');
      this.addEventListener('click', this._onClick.bind(this));
      this.addEventListener('change', this._onChange.bind(this));

      Z.on('cart:updated', (event) => {
        this._refresh();
        if (event.detail && event.detail.added) {
          this.open();
          Z.announce(Z.strings.addedToCart);
        }
      });

      document.querySelectorAll('[data-cart-open]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => { event.preventDefault(); this.open(); });
      });
    }

    async _refresh() {
      try {
        const doc = await Z.fetchSection(Z.routes.cart, 'cart-drawer-contents');
        const fresh = doc.querySelector('[data-cart-contents]');
        if (fresh && this._contents) this._contents.innerHTML = fresh.innerHTML;
      } catch (error) {
        window.location.href = Z.routes.cart;
      }
    }

    _onClick(event) {
      const up = event.target.closest('[data-qty-up]');
      const down = event.target.closest('[data-qty-down]');
      if (!up && !down) return;
      const item = event.target.closest('[data-line]');
      const input = item.querySelector('[data-qty-input]');
      const next = Math.max(0, parseInt(input.value, 10) + (up ? 1 : -1));
      this._update(item.dataset.line, next);
    }

    _onChange(event) {
      const input = event.target.closest('[data-qty-input]');
      if (!input) return;
      const item = input.closest('[data-line]');
      this._update(item.dataset.line, Math.max(0, parseInt(input.value, 10) || 0));
    }

    async _update(line, quantity) {
      this.setAttribute('aria-busy', 'true');
      try {
        await Z.cart.change({ line: Number(line), quantity: quantity });
      } catch (error) {
        Z.announce(Z.strings.error);
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('z-cart-drawer', CartDrawer);

  /* --- Ajout rapide depuis la grille et la fiche produit ------------------- */
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this._form = this.querySelector('form');
      if (!this._form) return;
      this._button = this._form.querySelector('[type="submit"]');
      this._form.addEventListener('submit', this._onSubmit.bind(this));
    }
    async _onSubmit(event) {
      event.preventDefault();
      if (this._button.dataset.loading === 'true') return;
      this._button.dataset.loading = 'true';
      try {
        const data = new FormData(this._form);
        await Z.cart.add([{ id: data.get('id'), quantity: Number(data.get('quantity') || 1) }]);
      } catch (error) {
        Z.announce(error.message || Z.strings.error);
      } finally {
        this._button.dataset.loading = 'false';
      }
    }
  }
  customElements.define('product-form', ProductForm);
})();
